
import { defineComponent, reactive } from 'vue'

import Modal from '@/common/components/UI/Modal/index.vue'
import FileReader from '@/common/components/UI/FileReader/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

import useNotifications from '@/common/composable/useNotifications'

import { orders } from '@/core/realisations/orders.realisation'

import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default defineComponent({
    components: {
        Modal,
        FileReader,
        TheButton,
    },
    props: {
        companyId: {
            type: Number,
            default: null,
        },
    },
    emits: ['cancel', 'order-created'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            file: [] as File[],
        })

        const state_form$ = useVuelidate(
            {
                file: { required },
            },
            state
        )

        const emitCancel = () => {
            if (state.is_loading) return
            emit('cancel')
        }

        const createOrder = async () => {
            if (!props.companyId) {
                notifications.notify({ type: 'danger', title: 'Не выбрана компания' })
                return
            }

            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            try {
                state.is_loading = true

                const form_data = new FormData()
                form_data.append('companyId', props.companyId.toString())

                form_data.append('file', state.file[0])

                await orders.createMultipleFTLOrderFromExcel(form_data)

                notifications.notify({ type: 'success', title: 'Заказ создан' })
                emit('order-created')
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При оптовом создании заказа произошла ошибка',
                })
            } finally {
                state.is_loading = false
            }
        }

        return {
            state,
            state_form$,
            emitCancel,
            createOrder,
        }
    },
})
